import { Component, Injector } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BasePageComponent } from '../../base.page';

@UntilDestroy()
@Component({
    selector: 'app-page-edit-user-security',
    templateUrl: './edit-user-security.page.html',
    styleUrls: ['./edit-user-security.page.scss'],
})
export class EditUserSecurityPage extends BasePageComponent {
    constructor(injector: Injector) {
        super(injector);
    }
}
